(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vg-nav-jump"] && !Shopify.designMode) return;
  try {
    
(() => {
  const nav = document.querySelector('[data-nav-jump]');
  if (!nav) return;

  const scroller = nav.querySelector('.nav-jump__scroller');
  const pills = Array.from(nav.querySelectorAll('[data-nav-jump-pill]'));
  if (!pills.length) return;

  // Map sectionId -> pill
  const pillById = new Map();
  pills.forEach((pill) => {
    const id = pill.getAttribute('data-nav-jump-target');
    if (id) pillById.set(id, pill);
  });

  function setActive(targetId, { scrollIntoView = true } = {}) {
    let activeEl = null;

    pills.forEach((pill) => {
      const isActive = pill.getAttribute('data-nav-jump-target') === targetId;
      pill.classList.toggle('is-active', isActive);
      pill.setAttribute('aria-selected', isActive ? 'true' : 'false');
      if (isActive) activeEl = pill;
    });

    // Keep active pill visible in horizontal overflow
    if (scrollIntoView && activeEl && scroller) {
      const elRect = activeEl.getBoundingClientRect();
      const scRect = scroller.getBoundingClientRect();
      if (elRect.left < scRect.left || elRect.right > scRect.right) {
        activeEl.scrollIntoView({
          behavior: 'smooth',
          inline: 'nearest',
          block: 'nearest'
        });
      }
    }
  }

  function getHashTarget() {
    const hash = window.location.hash || '';
    return hash.startsWith('#') ? hash.slice(1) : '';
  }

  // Initial active state (hash or first pill)
  const initialTarget =
    getHashTarget() || pills[0].getAttribute('data-nav-jump-target');

  if (initialTarget) {
    setActive(initialTarget, { scrollIntoView: false });
  }

  // Click: immediate UI response
  pills.forEach((pill) => {
    pill.addEventListener('click', () => {
      const id = pill.getAttribute('data-nav-jump-target');
      if (id) setActive(id);
    });
  });

  // Back/forward navigation
  window.addEventListener('hashchange', () => {
    const id = getHashTarget();
    if (id) setActive(id);
  });

  // ======================================================
  // OPTION B: "Last heading above the activation line"
  // (header-only anchors, stable up/down, no IntersectionObserver)
  // ======================================================

  const targets = Array.from(pillById.keys())
    .map((id) => document.getElementById(id))
    .filter(Boolean);

  if (!targets.length) return;

  function getTopLine() {
    const styles = getComputedStyle(nav);
    const headerDesktop =
      parseInt(styles.getPropertyValue('--nj-header-desktop')) || 115;
    const headerMobile =
      parseInt(styles.getPropertyValue('--nj-header-mobile')) || 55;

    const isMobile = window.matchMedia('(max-width: 749px)').matches;
    const header = isMobile ? headerMobile : headerDesktop;

    const navHeight = nav.getBoundingClientRect().height || 0;

    // Activation line just under sticky header + sticky nav
    return header + navHeight + 8;
  }

  let ticking = false;

  function updateActiveFromScroll() {
    ticking = false;

    const topLine = getTopLine();

    // Pick the LAST target whose top is above the activation line
    let bestId = null;
    let bestTop = -Infinity;

    for (const el of targets) {
      const top = el.getBoundingClientRect().top;
      if (top <= topLine && top > bestTop) {
        bestTop = top;
        bestId = el.id;
      }
    }

    // If we're above the first section, default to first
    if (!bestId) bestId = targets[0].id;

    setActive(bestId, { scrollIntoView: false });
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(updateActiveFromScroll);
  }

  // Run once on load (after initial hash state)
  updateActiveFromScroll();

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', () => updateActiveFromScroll(), { passive: true });
})();

  } catch(e) { console.error(e); }
})();
})();
